// A tiny event-based toast API you can call from anywhere.
export const toast = {
  show(detail) {
    window.dispatchEvent(new CustomEvent("toast", { detail }));
  },
  success(title, description) {
    toast.show({ title, description, variant: "success" });
  },
  error(title, description) {
    toast.show({ title, description, variant: "error" });
  },
  info(title, description) {
    toast.show({ title, description, variant: "info" });
  },
};
